import axios from 'axios';
import { ADD_USER } from '../../constants';

export const createUser = (data, onError, onNewClose) => (dispatch) => {
  const bodyFormData = new FormData();
  bodyFormData.append('name', data.name);
  bodyFormData.append('firstName', data.firstName);
  bodyFormData.append('lastName', data.lastName);
  bodyFormData.append('email', data.email);
  bodyFormData.append('phoneNumber', data.phoneNumber);
  bodyFormData.append('countryCode', data.countryCode);
  bodyFormData.append('role', data.role);
  bodyFormData.append('password', data.password);
  bodyFormData.append('color', data.color);
  if (data.jobTitle) bodyFormData.append('jobTitle', data.jobTitle);
  if (data.profilePicture)
    bodyFormData.append('profilePicture', data.profilePicture);
  const token = localStorage.jwtToken;
  dispatch(addUser());
  axios({
    method: 'post',
    url: `/admin/createUser`,
    data: bodyFormData,
    headers: {
      'Content-Type': 'multipart/form-data',
      Authorization: `Bearer ${token}`,
    },
  })
    .then((res) => {
      onNewClose();
      dispatch(setAddUser(res));
    })
    .catch((err) => {
      dispatch(errorAddUser(err.response));
      onError(err.response);
    });
};

export const addUser = () => ({
  type: ADD_USER.LOAD,
});

export const setAddUser = (data) => ({
  type: ADD_USER.SUCCESS,
  payload: data.data,
});

export const errorAddUser = (error) => ({
  type: ADD_USER.FAIL,
  payload: error,
});
